module.exports = __webpack_public_path__ + "static/media/thumb-designsteins.926f480d.png";